import { prodApiSlice } from '../../../../app/services/apiSlice';

export const publicPagesProdApiSlice = prodApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPreviewThemesLink: builder.query({
      query: () => ({
        url: `https://gateway.boostfloral.com/vendor/api/settings/template/public/website/predefined`,
      }),

      transformResponse: (responseData) => {
        return responseData?.objectData;
      },
    }),
  }),
});

export const { useGetPreviewThemesLinkQuery } = publicPagesProdApiSlice;
